import { render, staticRenderFns } from "./ChamadasInscricaoView_v3.vue?vue&type=template&id=8ac9ce4a&scoped=true"
import script from "./ChamadasInscricaoView_v3.vue?vue&type=script&lang=js"
export * from "./ChamadasInscricaoView_v3.vue?vue&type=script&lang=js"
import style0 from "./ChamadasInscricaoView_v3.vue?vue&type=style&index=0&id=8ac9ce4a&prod&scoped=true&lang=css"
import style1 from "./ChamadasInscricaoView_v3.vue?vue&type=style&index=1&id=8ac9ce4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac9ce4a",
  null
  
)

export default component.exports